import $axios from "@/api";

const state = () => ({
    data:[]
})

const mutations = {
    ASSIGN_DATA(state,response){
        state.data = response
    },
}

const actions = {
    async listLaporanSLASales({ commit }, filter) {
        try{
            const response =  await $axios.get(`report/sla_sales`,{params:filter})
            commit('ASSIGN_DATA',response.data.data)
        }catch(error){
            console.log(error)
        }
    },
}

export default {    
    namespaced: true,
    state,
    actions,
    mutations
}
